"use client";

import React from "react";
import dayjs from "dayjs";
import { Clock, PlayCircle } from "lucide-react";

import { Paragraph } from "@/components/ui/typography";

import LiveClassStatus from "./live-class-status";
import LiveClassAction from "./live-class-action";
import LiveClassNotification from "./live-class-notification";

import { cn } from "@/lib/utils";

function LiveClassCard({
  liveClass,
  onRangeChange,
  onTimeExpire,
  onWindowClose,
}) {
  return (
    <div
      className={cn(
        "relative flex flex-row bg-primary-foreground p-2 max-w-86.25",
        "border border-gray-200 rounded-md gap-x-3 hover:border-primary transition-colors duration-300"
      )}
    >
      <div
        className={cn(
          "relative inline-block bg-gradient-continue-watch-thumbnail rounded-md h-32 w-full",
          "p-2 size-27.5 select-none pointer-events-none shrink my-2 md:my-4"
        )}
      >
        <span className="text-xs text-white font-medium line-clamp-3 leading-4">
          {liveClass.topic}
        </span>

        <PlayCircle className="absolute bottom-2 right-2 text-white opacity-60" />
      </div>

      <div className="flex flex-col items-start justify-between h-full w-full flex-1 pt-2 md:w-auto">
        <div className="flex flex-col">
          <Paragraph variant="b4" weight="sb" className="h-11 line-clamp-2">
            {liveClass.topic}
          </Paragraph>
          <Paragraph
            variant="b5"
            className="mb-1 text-gray-500 line-clamp-1"
            as="span"
          >
            Course: <span>{liveClass.courseName}</span>
          </Paragraph>
          <Paragraph
            variant="b5"
            className="mb-1 text-primary-weak line-clamp-1"
          >
            By: {liveClass.facultyName}
          </Paragraph>

          <Paragraph
            variant="b5"
            className="flex items-center gap-x-1 text-gray-400"
          >
            <Clock size={12} />
            <span>
              {dayjs(liveClass.startTime).format("hh:mm A")} -{" "}
              {dayjs(liveClass.endTime).format("hh:mm A")}
            </span>
          </Paragraph>
        </div>

        <div className="mt-2.5 w-full border-t border-dashed border-gray-300">
          <LiveClassAction
            liveClass={liveClass}
            onRangeChange={onRangeChange}
            onWindowClose={onWindowClose}
            onTimeExpire={onTimeExpire}
          />
        </div>
      </div>

      <LiveClassStatus
        liveClass={liveClass}
        className="text-white bg-class-ended"
      />

      <LiveClassNotification liveClass={liveClass} />
    </div>
  );
}

export default LiveClassCard;
